import { Link } from "react-router-dom";
import DOMPurify from "dompurify";
import { G_API } from "../../constants/globalVar";

const DEFAULT_IMAGE = `${G_API}uploads/ahnyar-logo.png`;

export const SinglePostTemplate = ({ props: data }) => {
  const { title, description, image, updated_at, url } = data;

  const formattedDate = new Date(updated_at).toLocaleDateString();

  const cleanDescription = DOMPurify.sanitize(description, {
    ALLOWED_TAGS: [],
  });

  return (
    <div className="card h-100" style={{ width: "250px" }}>
      <img
        src={image || DEFAULT_IMAGE}
        className="card-img-top"
        alt={title}
        style={{
          objectFit: "cover",
          height: "250px",
          width: "250px",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = DEFAULT_IMAGE;
        }}
      />
      <div className="card-body d-flex flex-column">
        <h5 className="card-title text-truncate">{title}</h5>
        <p
          className="card-text text-muted"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: "1.6",
            minHeight: "4.8em",
          }}
        >
          {cleanDescription}
        </p>
        <div className="mt-auto">
          <Link className="btn btn-outline-warning btn-sm" to={url}>
            Read More
          </Link>
        </div>
      </div>
      <div className="card-footer bg-transparent border-top-0 text-end">
        <small className="text-muted">Updated {formattedDate}</small>
      </div>
    </div>
  );
};